import React, { createContext, useContext, useMemo, useState } from 'react';

import { ActiveMarkerContext as Context } from './types';

interface Props {
  children?: React.ReactNode;
}

export const HoveredMarkerContext = createContext({} as Context);
export const useHoveredMarkerContext = () => useContext(HoveredMarkerContext);

export const HoveredMarkerProvider = ({ children }: Props) => {
  const [ hoveredMarker, setHoveredMarker ] = useState<Context['hoveredMarker']>(null);

  const value = useMemo(() => ({
    hoveredMarker,
    setHoveredMarker
  }), [
    hoveredMarker,
    setHoveredMarker
  ]);

  return (
    <HoveredMarkerContext.Provider value={value}>{children}</HoveredMarkerContext.Provider>
  );
};
